import dayjs from 'dayjs';

export function getTimeSpan(times: number) {
  if (isNaN(+times)) {
    times = 0;
  }

  let d = Math.floor(times / 60 / 60 / 24); // 倒计时多少天
  let h = Math.floor((times / 60 / 60) % 24); // 倒计时多少小时
  let m = Math.floor((times / 60) % 60); // 倒计时多少分钟
  let s = Math.floor(times % 60); // 倒计时多少秒

  return {
    d,
    h,
    m,
    s,
  };
}

export function getTimeInFeed(timeUnix: number) {
  const duration = Date.now() / 1000 - timeUnix;

  const { d, h, m, s } = getTimeSpan(duration > 0 ? duration : 0);
  if (d) {
    return dayjs.unix(timeUnix).format('MMM D');
  }

  if (h) {
    return `${h}h`;
  }

  if (m) {
    return `${m}m`;
  }

  return !s ? 'now' : `${s}s`;
}

export const formatTimeReadable = (timeElapse: number) => {
  let timeStr = '';
  const { d, h, m, s } = getTimeSpan(timeElapse);

  if (d) timeStr = `${d} day` + (d > 1 ? 's' : '');
  if (h && !timeStr) timeStr = `${h} hr` + (h > 1 ? 's' : '');
  if (m && !timeStr) timeStr = `${m} min` + (m > 1 ? 's' : '');
  if (!timeStr) timeStr = `${s} sec` + (s > 1 ? 's' : '');
  return timeStr;
};

export const formatTimeReadableV2 = (timeElapse: number) => {
  let timeStr = '';
  const { d, h, m, s } = getTimeSpan(timeElapse);

  if (d) timeStr = `${d} day` + (d > 1 ? 's' : '');
  if (h && !timeStr) timeStr = `${h} hour` + (h > 1 ? 's' : '');
  if (m && !timeStr) timeStr = `${m} minute` + (m > 1 ? 's' : '');
  if (!timeStr) timeStr = `${s} second` + (s > 1 ? 's' : '');
  return timeStr;
};

export const getTimeFromNow = (create_at: number) =>
  formatTimeReadable(Date.now() / 1000 - create_at);

export function HistoryGetTimeAgo(time: number, currTime?: number) {
  let successTimeView = '';
  const successTime = getTimeSpan((currTime || Date.now() / 1000) - time);
  const { d, h, m, s } = successTime;
  let str = '';
  let flag = 0;
  if (d) {
    str += `${d}${`day${d > 1 ? 's' : ''}`} `;
    flag++;
  }
  if ((h || flag) && flag < 3) {
    str += `${h}${`hr${h > 1 ? 's' : ''}`} `;
    flag++;
  }
  if ((m || flag) && flag < 3) {
    str += `${m}${`min${m > 1 ? 's' : ''}`} `;
    flag++;
  }
  if ((s || flag) && flag < 2) {
    str += `${s}${`sec${s > 1 ? 's' : ''}`}`;
  }
  if (str) successTimeView = str;
  return successTimeView;
}

export function formatDate(timestamp: number, format = 'YYYY-MM-DD HH:mm:ss') {
  const date = new Date(timestamp);
  const readableDate: Record<string, any> = {
    YYYY: date.getFullYear(),
    MM: (date.getMonth() + 1).toString().padStart(2, '0'),
    DD: date.getDate().toString().padStart(2, '0'),
    HH: date.getHours().toString().padStart(2, '0'),
    mm: date.getMinutes().toString().padStart(2, '0'),
    ss: date.getSeconds().toString().padStart(2, '0'),
  };

  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, match => readableDate[match]);
}

export function secondsToMs(seconds: number) {
  return seconds * 1000;
}

export const DATE_FORMATER = 'MMM DD, YYYY';
export const DATE_TIME_FORMATER = 'MMM DD, HH:mm';

const ONE_DAY_SECONDS = 60 * 60 * 24;

export const getRelativeTime = (
  startStamp: number,
  {
    fullFormat = 'MM/DD HH:mm',
    humanizeSuffix,
  }: { fullFormat?: string; humanizeSuffix?: string } = {},
) => {
  const currentTime = +new Date() / 1000;

  const createAt = dayjs.unix(startStamp);
  const duration = currentTime - startStamp;

  return duration >= ONE_DAY_SECONDS
    ? createAt.format(fullFormat)
    : `${dayjs.duration(duration, 'seconds').humanize()}${humanizeSuffix || ''}`;
};
